import type { ReactElement } from "react";
import { Loader } from "ui-components/loader";

export function LoadingScreen({ label }: { label?: string } = {}): ReactElement {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <Loader color="indigo" size="medium" />
      {label ? <p className="text-sm text-zinc-500">{label}</p> : null}
    </div>
  );
}
